import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const ToggleList = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function ToggleList({ active, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M9 7.75C9.27614 7.75 9.5 7.52614 9.5 7.25V6.75C9.5 6.47386 9.27614 6.25 9 6.25H5C4.72386 6.25 4.5 6.47386 4.5 6.75V7.25C4.5 7.52614 4.72386 7.75 5 7.75H9Z'
          fill={active ? 'transparent' : color}
        />
        <path
          d='M9 10.25C9.27614 10.25 9.5 10.0261 9.5 9.75V9.25C9.5 8.97386 9.27614 8.75 9 8.75H5C4.72386 8.75 4.5 8.97386 4.5 9.25V9.75C4.5 10.0261 4.72386 10.25 5 10.25H9Z'
          fill={active ? 'transparent' : color}
        />
        <path
          d='M9 12.75C9.27614 12.75 9.5 12.5261 9.5 12.25V11.75C9.5 11.4739 9.27614 11.25 9 11.25H5C4.72386 11.25 4.5 11.4739 4.5 11.75V12.25C4.5 12.5261 4.72386 12.75 5 12.75H9Z'
          fill={active ? 'transparent' : color}
        />
        <path
          d='M9 15.25C9.27614 15.25 9.5 15.0261 9.5 14.75V14.25C9.5 13.9739 9.27614 13.75 9 13.75H5C4.72386 13.75 4.5 13.9739 4.5 14.25V14.75C4.5 15.0261 4.72386 15.25 5 15.25H9Z'
          fill={active ? 'transparent' : color}
        />
        <path
          d='M9 17.75C9.27614 17.75 9.5 17.5261 9.5 17.25V16.75C9.5 16.4739 9.27614 16.25 9 16.25H5C4.72386 16.25 4.5 16.4739 4.5 16.75V17.25C4.5 17.5261 4.72386 17.75 5 17.75H9Z'
          fill={active ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.5 5C22.5 3.89543 21.6046 3 20.5 3H3.5C2.39543 3 1.5 3.89543 1.5 5V19C1.5 20.1046 2.39543 21 3.5 21H20.5C21.6046 21 22.5 20.1046 22.5 19V5ZM20.5 4.5H12.75V19.5H20.5C20.7761 19.5 21 19.2761 21 19V5C21 4.72386 20.7761 4.5 20.5 4.5ZM3.5 4.5H11.25V19.5H3.5C3.22386 19.5 3 19.2761 3 19V5C3 4.72386 3.22386 4.5 3.5 4.5Z'
          fill={active ? 'transparent' : color}
        />

        {/* active */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.5 3C21.6046 3 22.5 3.89543 22.5 5V19C22.5 20.1046 21.6046 21 20.5 21H3.5C2.39543 21 1.5 20.1046 1.5 19V5C1.5 3.89543 2.39543 3 3.5 3H20.5ZM11.25 4.5H3.5C3.22386 4.5 3 4.72386 3 5V19C3 19.2761 3.22386 19.5 3.5 19.5H11.25V4.5ZM14.5 7.25C14.5 7.52614 14.7239 7.75 15 7.75H19C19.2761 7.75 19.5 7.52614 19.5 7.25V6.75C19.5 6.47386 19.2761 6.25 19 6.25H15C14.7239 6.25 14.5 6.47386 14.5 6.75V7.25ZM14.5 9.75C14.5 10.0261 14.7239 10.25 15 10.25H19C19.2761 10.25 19.5 10.0261 19.5 9.75V9.25C19.5 8.97386 19.2761 8.75 19 8.75H15C14.7239 8.75 14.5 8.97386 14.5 9.25V9.75ZM14.5 12.25C14.5 12.5261 14.7239 12.75 15 12.75H19C19.2761 12.75 19.5 12.5261 19.5 12.25V11.75C19.5 11.4739 19.2761 11.25 19 11.25H15C14.7239 11.25 14.5 11.4739 14.5 11.75V12.25Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'toggle-list-icon-svg'} iconRender={iconRender} {...props} />;
});

export default ToggleList;
